module.exports = __webpack_public_path__ + "static/media/digital-work1.9c304aaa.jpg";